import React, { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import SGSTooltip from '../../SGSTooltip';
import classnames from 'classnames';

type Props = React.HTMLAttributes<HTMLElement> & {
    title?: string;
    icon: string;
    onClick?: () => void;
};

const SGSIcon: React.FC<PropsWithChildren<Props>> = ({ title, icon, onClick, className }) => {
    const { t } = useTranslation();
    const handleClick = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        e.stopPropagation();
        if (onClick) onClick(e);
    };
    return title ? (
        <SGSTooltip title={t(title)} clickable className={classnames('d-inline-block', className)}>
            <i className={icon} onClick={handleClick} />
        </SGSTooltip>
    ) : (
        <i className={icon} onClick={handleClick} />
    );
};

export default SGSIcon;
